import { AppointmentTimeOfDay } from 'apps/wrapper/src/services/appointment/types/appointment-time-of-day';

export const getTimeOfDayText = (value?: AppointmentTimeOfDay): string | null => {
  if (!value) return null;

  if (value === (AppointmentTimeOfDay.Morning | AppointmentTimeOfDay.Afternoon | AppointmentTimeOfDay.Evening))
    return 'Anytime';

  const parts: string[] = [];

  if (value & AppointmentTimeOfDay.Morning) parts.push('Mornings');
  if (value & AppointmentTimeOfDay.Afternoon) parts.push('Afternoons');
  if (value & AppointmentTimeOfDay.Evening) parts.push('Evenings');

  return parts.join(' or ');
}